import React from "react";

const CloseIcon = ({ alt = "Close", style = {} }) => {
	return (
		<img 
			alt={alt} 
			src="https://res.cloudinary.com/drsmugc99/image/upload/v1752725712/close_sieoy9.svg" 
			style={style}
		/>
	);
};

export default CloseIcon; 